import config from "../config";
import HTTPService from "./HTTPService";

export default class ConfigService {
  static getHeaders() {
    return {
      source: localStorage.getItem("source"),
      "X-Authorization-Token": localStorage.getItem(`X-Authorization-Token`),
    };
  }

  static getAppConfig = () => {
    const source = localStorage.getItem("source");
    const url = `${config.versionService}/v1/config/?language=en&source=${source}&version=100`;
    return HTTPService.makeXHRRequest(url, "GET", null, this.getHeaders());
  };
}
